import { render } from "./ley.vue?vue&type=template&id=31d442be&scoped=true"
import script from "./ley.vue?vue&type=script&lang=js"
export * from "./ley.vue?vue&type=script&lang=js"

import "./ley.vue?vue&type=style&index=0&id=31d442be&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d442be"]])

export default __exports__